export class RegisterModel {
	email?: string;
	emailError?: any;

	constructor(data: any = {}) {
		this.email = data.email || "";
	}
}
